import { render, staticRenderFns } from "./overlay_image_code.vue?vue&type=template&id=afd74578&scoped=true&lang=pug&"
import script from "./overlay_image_code.vue?vue&type=script&lang=js&"
export * from "./overlay_image_code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd74578",
  null
  
)

export default component.exports